const normalizeDeductionTypeId = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  return String(value);
};

export const formatAdditionalExpenseCurrency = (value) =>
  `$${Number(value || 0).toFixed(2)}`;

export const mapDeductionTypeChoices = (choices = []) =>
  choices.map((choice) => ({
    id: normalizeDeductionTypeId(choice.value),
    label: choice.display_name,
  }));

export const buildDeductionTypeDisplayMap = (choices = []) =>
  choices.reduce((acc, choice) => {
    acc[choice.id] = choice.label;
    return acc;
  }, {});

export const getDeductionTypeLabel = (displayMap, deductionType) =>
  (displayMap?.[normalizeDeductionTypeId(deductionType)] || "").replace("Deducted from", "").trim();

export const mapAdditionalExpenseToFormValues = (expense = null) => ({
  deductionType: expense?.deductionType ?? expense?.deduction_type ?? "3",
  label: expense?.label ?? "",
  amount: expense?.amount ?? "",
});

export const buildAdditionalExpensePayload = (formValues, caseId = null) => {
  const payload = {
    label: formValues.label,
    amount:
      formValues.amount === "" || formValues.amount === null || formValues.amount === undefined
        ? 0
        : Number(formValues.amount),
    deduction_type: Number(formValues.deductionType),
  };

  if (caseId) {
    payload.case = Number(caseId);
  }

  return payload;
};

export const buildAdditionalExpenseDirtyPayload = (initialValues, currentValues) => {
  const initialPayload = buildAdditionalExpensePayload(initialValues);
  const currentPayload = buildAdditionalExpensePayload(currentValues);

  return Object.fromEntries(
    Object.entries(currentPayload).filter(([key, value]) => initialPayload[key] !== value)
  );
};

export const isAdditionalExpenseDirty = (initialValues, currentValues) =>
  Object.keys(buildAdditionalExpenseDirtyPayload(initialValues, currentValues)).length > 0;

export const isAdditionalExpenseSaveDisabled = (formValues) =>
  formValues.deductionType === "" ||
  formValues.deductionType === null ||
  formValues.deductionType === undefined;
